import { eIssueStatus, tIssue } from "../data/Issues";
import { team } from "../data/Team";
import { getBorderColor, getIssueIcon } from "../helper/HelperFunctions";
import './PlannedIssueCard.css'; // Add this to import the styles

interface PlannedIssueCardProps {
    issue: tIssue;
    onClickCallback: (issueId: number) => void;
}

export default function PlannedIssueCard(props: PlannedIssueCardProps) {
    // Destructure the issue object from props
    const { title, storyPoints, mainElement, assignee, epic } = props.issue;

    // Get the border color based on the mainElement
    const borderColor = getBorderColor(mainElement);

    // If no one is assigned, use a placeholder icon
    const teamMemberIcon = assignee === 0 ? '👤' : team.find(tm => tm.id === assignee)?.icon

    return (
        <div className="planned-issue-card" style={{ borderColor }} onClick={() => props.onClickCallback(props.issue.id)}>
            <h3>{getIssueIcon(props.issue.type)}{title}</h3>
            <div style={{bottom: '35px'}} className={`epic-tag epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}>{epic}</div>
            <div className="assigned-to">
                {props.issue.status !== eIssueStatus.Done ? <span>{teamMemberIcon}</span> : null}
                <div className='planned-issue-card-worked-on'>
                    {props.issue.dev && <span>[💻{team.find(tm => tm.id === props.issue.dev)?.icon}]</span>}
                    {props.issue.qa && <span>[🔍{team.find(tm => tm.id === props.issue.qa)?.icon}]</span>}
                </div>
            </div>
            <div className="story-points">
                <span className="tooltip">Story Points</span>
                <p>{storyPoints}</p>
            </div>
        </div>
    );
}
